import React, { ReactNode } from 'react';
import { Routes, Route } from 'react-router-dom';
import './DoctorLayout.css';
import DHeader from '../../Header/DHeader';
import DoctorMenu from '../../doctor/doctormenu/DoctorMenu';
import  DoctorDashboard  from '../../doctor/DoctorDashboard';
import { DoctorCases } from '../../doctor/DoctorCases';
import { DoctorReports } from '../../doctor/DoctorReports';
import {DoctorAppointments} from '../../doctor/DoctorAppointments';
import { DoctorActivities } from '../../doctor/DoctorActivities';
import { DoctorProfile } from '../../doctor/DoctorProfile';
import { DoctorProfileUplaods } from '../../doctor/DoctorProfileUplaods';
import { DoctorViewOpenCase } from '../../doctor/DoctorViewOpenCase';
import { PatientHistory } from '../../doctor/PatientHistory';
import { DoctorNotes } from '../../doctor/DoctorNotes';
import { InvoicePrint } from '../../doctor/InvoicePrint';
import { Reset } from '../../reset/Reset';
interface DoctorLayout {
  children?: ReactNode;
  // Define children as a ReactNode
}
const DoctorLayout: React.FC<DoctorLayout> = ({ children }) => {
  return (
    <div className="elitecap-layout-container">
      <DHeader/>
      <div >
        <DoctorMenu />
          <Routes>
             <Route path="/doctordashboard" element={<DoctorDashboard />} />
             <Route path="/doctorcaseslists" element={<DoctorCases />} />
             <Route path="/doctorreports" element={<DoctorReports />} />
             <Route path="/doctorappointments" element={<DoctorAppointments />} />
            <Route path="/doctoractivities" element={<DoctorActivities />} /> 
             <Route path="/doctorprofile" element={<DoctorProfile />} />
             <Route path="/doctoruploads" element={<DoctorProfileUplaods />} />
             <Route path="/casedetails/:id" element={<DoctorViewOpenCase />} />
             <Route path="/viewpatienthistory/:id" element={<PatientHistory />} />
             <Route path="/doctornotes/:id" element={<DoctorNotes />} />
             <Route path="/invoice/:id" element={<InvoicePrint />} />
              <Route path="/doctorresetpassword" element={<Reset />} />


             



             
             




             






          </Routes>
      </div>
      { children }
      {/* <Footer /> */}
    </div>
  );
};

export default DoctorLayout;
